import React from "react";
import "./CTA_Style.css";
const Cta = () => {
  return (
    <div className="gpt3__cta section__padding">
      <div className="gpt3__cta-container">
        <p>Request Early Access to Get Started</p>
        <h4>Register today & start exploring the endless possiblities.</h4>
      </div>
      <button type="button"> Get Started</button>
    </div>
  );
};

export default Cta;
